<template>
  <div class="sticky top-16 z-30 bg-blue-50/95 backdrop-blur py-3">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav class="relative grid grid-cols-4 bg-white border border-blue-100 rounded-lg shadow-sm overflow-visible">
        <button
          v-for="tab in primaryTabs"
          :key="tab.key"
          type="button"
          class="relative min-w-0 h-14 px-2 flex items-center justify-center gap-1.5 text-sm font-medium transition-colors"
          :class="activeTab === tab.key ? 'text-blue-950' : 'text-gray-500 hover:text-blue-800'"
          :aria-label="tab.label"
          @click="navigate(tab.key)"
        >
          <span class="material-symbols-outlined text-2xl sm:text-xl">{{ tab.icon }}</span>
          <span class="hidden sm:inline truncate">{{ tab.label }}</span>
          <span
            v-if="tab.key === 'network' && connectionRequestsCount > 0"
            class="absolute top-1 right-1 sm:static h-5 min-w-5 px-1 rounded-full bg-red-500 text-white text-xs flex items-center justify-center"
          >
            {{ connectionRequestsCount }}
          </span>
          <span
            v-if="activeTab === tab.key"
            class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-700"
          ></span>
        </button>

        <button
          type="button"
          class="relative min-w-0 h-14 px-2 flex items-center justify-center gap-1.5 text-sm font-medium transition-colors"
          :class="moreOpen ? 'text-blue-950' : 'text-gray-500 hover:text-blue-800'"
          aria-label="More social options"
          @click.stop="moreOpen = !moreOpen"
        >
          <span class="material-symbols-outlined text-2xl sm:text-xl">more_horiz</span>
          <span class="hidden sm:inline truncate">More</span>
          <span
            v-if="moreOpen"
            class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-700"
          ></span>
        </button>

        <div
          v-if="moreOpen"
          class="absolute right-0 top-full mt-2 w-48 bg-white border border-gray-100 rounded-lg shadow-lg overflow-hidden text-left z-40"
        >
          <button
            v-for="item in moreItems"
            :key="item.key"
            type="button"
            class="w-full px-4 py-3 flex items-center gap-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
            @click="navigate(item.key)"
          >
            <span class="material-symbols-outlined text-lg">{{ item.icon }}</span>
            <span>{{ item.label }}</span>
          </button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialsPrimaryNav',
  props: {
    activeTab: {
      type: String,
      required: true
    },
    connectionRequestsCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['navigate'],
  data() {
    return {
      moreOpen: false,
      primaryTabs: [
        { key: 'discover', label: 'Discover', icon: 'explore' },
        { key: 'network', label: 'Network', icon: 'hub' },
        { key: 'chat', label: 'Chat', icon: 'chat' }
      ],
      moreItems: [
        { key: 'posts', label: 'Posts', icon: 'article' },
        { key: 'hustleup', label: 'HustleUP', icon: 'shopping_bag' }
      ]
    };
  },
  methods: {
    navigate(tabKey) {
      this.moreOpen = false;
      this.$emit('navigate', tabKey);
    }
  }
};
</script>
